import React, { useContext } from 'react'
import { Button } from 'react-bootstrap'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import config from '../../config/config'
import { LOGIN_PATH } from '../../config/routes'
import { formatDate } from '../../utils/dateUtils'
import { useAuth, AuthContext } from '../../contexts/AuthContext'
import { setFlashMessage, useWebsite } from '../../contexts/WebsiteContext'

const ContactThumbnail = ({ contact, onStatusChange }) => {
  const { t } = useTranslation()
  const { token } = useAuth()

  const navigate = useNavigate()
  const { logout } = useContext(AuthContext)

  const updateStatus = async (status) => {
    try {
      await axios.put(
        `${config.apiUrl}contact/${contact.id}`,
        { status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      onStatusChange(contact.id, status)
      setFlashMessage(t('SUCCESS_STATUS_UPDATED_MESSAGE'), 'success')
    } catch (error) {
      //console.error('Error webservice call:', error);

      if (error.response && error.response.status === 401) {
        logout()
        navigate(LOGIN_PATH)
      } else if (error.response) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
        console.error('Erreur lors du PUT contact ', contact.id)
      }
    }
  }

  return (
    <div className="green-frame" style={{ margin: '5px 10px' }}>
      <h5>
        {contact.name} - {contact.email}
      </h5>
      <div style={{ fontStyle: 'italic' }}>
        Postée le {formatDate(contact.createdAt, true)}
      </div>
      <p>{contact.message}</p>
      <div>
        {contact.status !== 'NEW' && (
          <Button
            variant="primary"
            onClick={() => updateStatus('NEW')}
            style={{ margin: '5px' }}
          >
            Marquer comme "Nouveau"
          </Button>
        )}
        {contact.status !== 'PROCESSED' && (
          <Button
            variant="primary"
            onClick={() => updateStatus('PROCESSED')}
            style={{ margin: '5px' }}
          >
            Marquer comme "Traité"
          </Button>
        )}
        {contact.status !== 'ARCHIVED' && (
          <Button
            variant="primary"
            onClick={() => updateStatus('ARCHIVED')}
            style={{ margin: '5px' }}
          >
            Marquer comme "Archivé"
          </Button>
        )}
      </div>
    </div>
  )
}

export default ContactThumbnail
